import _isFunction from 'lodash/isFunction'
import _merge from 'lodash/merge'

import apiAxios from '../../_framework/axios/api-axios'
import Store from '../../_stores/StoreCollection.js'

let TripsDashboardsCollection = {}

_merge(TripsDashboardsCollection, Store, {
  state: {
    apiBaseUrl: '/api/v1/trip-dashboards'
  }
})

/*
|--------------------------------------------------------------------------
| TRIP CLASS
|--------------------------------------------------------------------------
*/

class TripDashboard {
  static hasAgent(trip) {
    return trip && trip.travel_agent_id && trip.travel_agent
  }
}

/*
|--------------------------------------------------------------------------
| HELPERS METHODS
|--------------------------------------------------------------------------
*/

function setupDashboard($store, dashboardId, dashboardData, callback = null) {
  $store.commit('setCurrentDashboard', {
    dashboardId,
    data: dashboardData
  })

  setupDashboardResources($store, dashboardId, callback)
}

function setupDashboardResources($store, dashboardId, callback = null) {
  // @todo, refactor this with V2 resources
  $store.dispatch('setupTripResources')

  Promise.all([
    // note: we could use a hook system for this?
    $store.dispatch('AttachmentsV2/fetch'),
    $store.dispatch('PIFsV2/bootFor', ['where', 'trip_dashboard_id', dashboardId]),
    $store.dispatch('Invoices/bootFor', ['where', 'trip_dashboard_id', dashboardId])
  ]).then(() => {
    if (_isFunction(callback)) {
      callback()
    }
  })
}

function toggleOmitTermsAndConditionsSignature($store, dashboardId) {
  apiAxios
    .get(`v1/trip-dashboard/${dashboardId}/toggleOmitTermsAndConditionsSignature`)
    .then(res => {
      $store.dispatch('updateTripDashboardOmitTermsAndConditionsSignature', res.data)
    })
}
/*
|--------------------------------------------------------------------------
| EXPORTS
|--------------------------------------------------------------------------
*/

export default TripsDashboardsCollection
export {
  TripsDashboardsCollection,
  TripDashboard,
  setupDashboard,
  setupDashboardResources,
  toggleOmitTermsAndConditionsSignature
}
